
const LIST_TYPES = ['tereny', 'hale', 'biura', 'inwestorzy']
export const LIST_TYPES_JST = ['tereny', 'inwestorzy']
const LIST_TYPES_NO_JST = ['hale', 'biura']


export function prepareNav(data) {
    if (data.listType !== undefined && LIST_TYPES.find(x => x === data.listType) === undefined) {
        console.error("Invalid listType", data.listType)
    }
    if (LIST_TYPES_NO_JST.find(x => x === data.listType)) {
        data = {
            ...data,
            powiatId: undefined,
            gminaId: undefined,
        }
    }
    if (data.gminaId) {
        data.powiatId = undefined
    }
    return data
}
